import { HistoryTransactionDetailsRow } from "../transactions/views/historyTransactionDetailsViewConfig";
import { PairedTransactionData, pairedTransactionDataSchema } from "./schema";

export interface TransferPairData {
    transaction: PairedTransactionData;
    pairedTransaction: PairedTransactionData;
}

const extractTransactionData = (
    row: HistoryTransactionDetailsRow,
    descriptionLabel?: string,
): PairedTransactionData => {
    const resource = row.resource ?? {};
    return pairedTransactionDataSchema.parse({
        id: row.resourceId,
        amount: resource.amount,
        originalAmount: resource.originalAmount,
        date: resource.date,
        bankDescription: descriptionLabel ?? resource.bankDescription,
        displayDescription: resource.displayDescription,
        categoryId: resource.categoryId,
        entityId: resource.entityId,
        financialAccountId: resource.financialAccountId,
    });
};

export function getTransferPairs(
    data: HistoryTransactionDetailsRow[],
    isMatched?: boolean,
): TransferPairData[] {
    const pairs: Map<string, TransferPairData> = new Map();

    for (const row of data) {
        if (row.field !== "pairedTransferId") {
            continue;
        }

        const pairedTransferId = (isMatched ? row.newValue : row.oldValue)
            .value;

        const pairedTransactionRow = data.find(
            (item) => Number(item.resourceId) === Number(pairedTransferId),
        );

        if (!pairedTransactionRow) {
            continue;
        }
        const key = pairedTransferId + "-" + row.resourceId;
        const reversedKey = row.resourceId + "-" + pairedTransferId;

        if (pairs.has(reversedKey) || pairs.has(key)) {
            continue;
        }

        const transactionDescriptionLabel = (
            isMatched
                ? pairedTransactionRow.newValue
                : pairedTransactionRow.oldValue
        ).valueLabel;

        const pairedTransactionDescriptionLabel = (
            isMatched ? row.newValue : row.oldValue
        ).valueLabel;

        pairs.set(key, {
            transaction: extractTransactionData(
                row,
                transactionDescriptionLabel,
            ),
            pairedTransaction: extractTransactionData(
                pairedTransactionRow,
                pairedTransactionDescriptionLabel,
            ),
        });
    }
    return Array.from(pairs.values());
}

export function getPairKey(pair: TransferPairData): string {
    return `${pair.transaction.id}-${pair.pairedTransaction.id}`;
}
